var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('Overlay',{attrs:{"image":_vm.config.HEADER_BACKGROUND,"dimmed":""}}),_c('img',{staticClass:"logo",attrs:{"src":_vm.config.HEADER_LOGO}}),_c('h3',[_vm._v(_vm._s(_vm.config.HEADER_TITLE))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }